// extracted by mini-css-extract-plugin
export default {"headphonesPrice":"CartProd_headphonesPrice__2iSkK","prodTitle":"CartProd_prodTitle__PHY3v","prodPrice":"CartProd_prodPrice__Hj-rl"};